<template>
  <form
    id="audioStickerForm"
    name="audioSticker"
    class="my-3"
    @submit.prevent="submit"
  >
    <div class="text-center">
      <h2
        v-t="{
          path: 'audioStickerOverlay.chooseSticker.header',
          args: [participant ? participant.firstname : '']
        }"
      />
      <p
        v-t="{
          path: 'audioStickerOverlay.chooseSticker.text',
          args: [participant ? participant.firstname : '']
        }"
      />
    </div>

    <div class="container">
      <div class="row justify-content-center my-3">
        <template v-for="{ name, src } in stickers">
          <AudioStickerRadioButton
            v-if="src"
            :key="name"
            v-model="sticker"
            :value="name"
            :src="src"
            :class="$style.radioButton"
            name="audioSticker"
          />
        </template>
      </div>

      <div class="position-relative text-center">
        <transition name="fade">
          <div
            v-if="success"
            v-t="{ path: 'audioStickerOverlay.success.message', args: [participant ? participant.firstname : '']}"
            role="alert"
            class="alert alert-gray-800 white-space-pre mt-3 w-100 position-absolute bottom-0"
          />
        </transition>
      </div>

      <div class="text-center">
        <button
          class="btn btn-secondary btn-block mt-3"
          type="submit"
          :disabled="loading"
        >
          {{ $t('audioRecorder.submit') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import AudioStickerRadioButton from '@/components/AudioStickerRadioButton.vue'
import { getStickers, postSticker } from '@/api'

export default {
  components: {
    AudioStickerRadioButton
  },
  props: {
    participant: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      stickers: [],
      sticker: '',
      loading: false,
      success: false
    }
  },
  async beforeMount() {
    this.stickers = await getStickers()
    this.sticker = this.stickers[0]?.name
    this.loading = false
  },
  methods: {
    async submit() {
      this.loading = true
      await postSticker(this.sticker, this.participant.userId)
      this.success = true
      setTimeout(() => {
        this.success = false
      }, 2e3)
      this.loading = false
    }
  }
}
</script>

<style lang="scss" module>
.radioButton {
  border-width: .3125rem;

  img {
    width: 5rem;
    height: 5rem;
  }
}
</style>
